import { ProductHorizontal, ProductHorizontalProps } from './product-horizontal'

import * as gtm from '../../services/gtm'

import { Product } from 'src/services/searchProducts/dtos'
import { ProductApi } from 'src/types'

type ProductHorizontalWithAnalyticsProps = {
  analyticsProduct?: ProductApi | Product
  isFavoritos?: boolean
  shouldSendGoogleAnalyticsEventRequest?: boolean
} & ProductHorizontalProps

export const ProductHorizontalWithAnalytics = ({
  analyticsProduct,
  product,
  onClick,
  shouldSendGoogleAnalyticsEventRequest = true,
  ...rest
}: ProductHorizontalWithAnalyticsProps) => {
  const sendToGoogleAnalytics = () => {
    if (analyticsProduct?.selectedSku) {
      gtm.productClick(analyticsProduct)
    }
  }

  const handleProductClick = async (
    product: ProductHorizontalProps['product']
  ) => {
    if (shouldSendGoogleAnalyticsEventRequest) {
      sendToGoogleAnalytics()
    }

    onClick?.(product)
  }

  return (
    <ProductHorizontal
      product={product}
      onClick={handleProductClick}
      {...rest}
    />
  )
}
